var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 20.3998H1.2C0.537608 20.3998 0 20.9374 0 21.5998C0 22.2623 0.537608 22.7999 1.2 22.7999H22.8C23.4624 22.7999 24 22.2623 24 21.5998C24 20.9374 23.4624 20.3998 22.8 20.3998ZM1.2 3.59983H22.8C23.4624 3.59983 24 3.06226 24 2.39983C24 1.7374 23.4624 1.19983 22.8 1.19983H1.2C0.537608 1.19987 0 1.73744 0 2.39987C0 3.06226 0.537608 3.59983 1.2 3.59983ZM22.8 10.7998H1.2C0.537608 10.7998 0 11.3374 0 11.9999C0 12.6623 0.537608 13.1999 1.2 13.1999H22.8C23.4624 13.1999 24 12.6623 24 11.9999C24 11.3375 23.4624 10.7998 22.8 10.7998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.17f687710211a91bfe71622eac840ee2.svg";
export { ForwardRef as ReactComponent };